import React from 'react';
import strings from "../../utils/property-file/manageLeave.json";
import constants from '../../utils/constants';
import { useNavigate } from "react-router-dom";
import './manageLeave.css';


export default function MangeLeave() {
  const nav = useNavigate();

  return (
    <>
      <div >
        <div className="setting-details-sub-container mt-3">
        <div className="security-feature">
        <div className="setting-feature-one">
           
            <div className='password-feature row'>
                <p className='password-change-option col-11 mt-2 p-0 ml-3' onClick={(()=>{nav(constants.navigationLink.scheduleLeaves)})}><i className="ri-umbrella-line ml-3 icon-manage-leave"></i><span className='p-3'>{strings.scheduleLeave}</span></p>
                 <i className="ri-arrow-right-s-line text-end arrow-setting col-1 mt-2 p-0"></i>
                 
            <div className='feature-separate'></div>
          </div>
            <div className='password-feature row mt-4'>
                <p className='password-change-option col-11 mt-2 p-0 ml-3' onClick={(()=>{nav(constants.navigationLink.scheduleHoliday)})}><i className="ri-calendar-event-line ml-3 icon-schedule-leave"></i><span className='p-3'>{strings.scheduleHoliday}</span></p>
                 <i className="ri-arrow-right-s-line text-end arrow-setting col-1 mt-2 p-0"></i>
                 
            
          </div>
        </div> 
        </div>
        
        </div>
        
    </div>
    </>
  )
}
